import { Checkbox, Typography } from '@mui/material';
import { Grid } from '@mui/system';
import { EmailsCheckboxProps } from './EmailsCheckbox.props';

const EmailsCheckbox = ({ options }: EmailsCheckboxProps) => (
  <>
    {options.map(option => (
      <Grid key={option.name} container spacing={1} sx={{ gap: '8px' }}>
        <Grid>
          <Checkbox
            checked={option.checked}
            onChange={option.onChange}
            slotProps={{ input: { 'aria-label': option.ariaLabel } }}
            name={option.name}
          />
        </Grid>
        <Grid size={11} sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant="body1">{option.label}</Typography>
        </Grid>
      </Grid>
    ))}
  </>
);

export default EmailsCheckbox;

